// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.ajax-loader[data-v-1856bb67] {
    position: fixed;
    z-index: 1000;
    top: 0;
    left: 0;
    width: 100%;
    height: 2px;
    animation: glowingLine-1856bb67 500ms infinite;
}
@keyframes glowingLine-1856bb67 {
0% {
        background-color: #fff;
}
50% {
        background-color: aqua;
}
100% {
        background-color: #fff;
}
}
`, "",{"version":3,"sources":["webpack://./src/common/AjaxLoading.vue"],"names":[],"mappings":";AAwBA;IACA,eAAA;IACA,aAAA;IACA,MAAA;IACA,OAAA;IACA,WAAA;IACA,WAAA;IACA,8CAAA;AACA;AAEA;AACA;QACA,sBAAA;AACA;AACA;QACA,sBAAA;AACA;AACA;QACA,sBAAA;AACA;AACA","sourcesContent":["<script setup>\nimport { computed, getCurrentInstance } from 'vue';\n\nconst { proxy } = getCurrentInstance();\nconst store = proxy.$store;\n\n/**\n * We map this to the global store state.\n * Assuming your store has a 'request' module or a global 'loading' state.\n */\nconst ajaxRequestInProgress = computed(() => {\n    // Adjusted to check the central 'request' state or similar Vuex flag\n    return store.state.request?.ajaxRequestInProgress || false;\n});\n</script>\n\n<template>\n    <div\n        v-if=\"ajaxRequestInProgress\"\n        class=\"ajax-loader\"\n    />\n</template>\n\n<style scoped>\n.ajax-loader {\n    position: fixed;\n    z-index: 1000;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 2px;\n    animation: glowingLine 500ms infinite;\n}\n\n@keyframes glowingLine {\n    0% {\n        background-color: #fff;\n    }\n    50% {\n        background-color: aqua;\n    }\n    100% {\n        background-color: #fff;\n    }\n}\n</style>"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
